import { Box } from "@mui/material";
import DynamicTable from "../../../../data/DynamicTable/dynamicTable";

import { useEffect, useState } from "react";
import { fetchDataEngine } from "../../../../data/Axios/DynamicService";

import {
  imprestApplicationsByUser,
  leaveApplications,
  leaveApplicationsByUser,
  imprestApprover,
  approvedDisbursedImprests,
  ApprovedDisbursedClaims,
  AllStatutoryComponent,
} from "../../../../data/Queries/HRmanagement/leavemanagement";

import {
  LeaveApplicationsColumns,
  approvedClaimstApplicationsColumns,
} from "../../../../data/Columns/hrmanagement";

import { HRService } from "../../../../config";


import { statutoryComponentsColumns } from "../../../../data/Columns/hrmanagement";
import { allStatutoryComponentsQuery } from "../../../../data/Queries/HRmanagement/leavemanagement";

import StatutoryForm from "./StatutoryForm";
import { tokens } from "../../../../theme";

const base_url = HRService.uri;

  
const actions = {
 
  entity: "Payroll Setup",
  isSubright:true,
  edit: {
    key: "EDIT",
    button_name: "Edit",
    Show_Button: true,
    permission: "EditPermission",
    
  },
  add: {
    key: "ADD",
    button_name: "Add",
    Show_Button: false,
    permission: "CreatePermission",
    
  },
  activateDeactivate: {
    key: "ACTIVATEDEACTIVATE",
    button_name: "Deactivate",
    Show_Button: false,
    permission: "ActivatePermission",
  },
  

//  // ---------- APPROVE ----------
//   APPROVECLAIM: {
//     key: "APPROVECLAIM",
//     button_name: "Approve",
//     Show_Button: (row) => row.statusId === 1,   // only when pending
//     permission: "hasNoPermission",
//     roleGroupId: [1, 2, 3, 4],
//   },

//   // ---------- REJECT ----------
//   REJECTCLAIM: {
//     key: "REJECTCLAIM",
//     button_name: "Reject",
//     Show_Button: (row) => row.statusId === 1,   // only when pending
//     permission: "hasNoPermission",
//     roleGroupId: [1, 2, 3, 4],
//   },
 ViewStatutoryLines: {
      key: "ViewStatutoryLines",
      button_name: "View Bands",
      Show_Button: true,
      permission: "hasNoPermission",
      roleGroupId: [1, 2, 3, 4],
    },  
  showStatus: true,

};

  function StatutoryTable() { 
    return (
      <Box m="2px">
        <>
          <DynamicTable
            title="Statutory"
            subtitle="View all the Statutory Details, create or update it"
            columns={statutoryComponentsColumns}
            FormComponent={StatutoryForm}
            query={AllStatutoryComponent}
            actions={actions}
            base_url={base_url}
          />
        </>
      </Box>
    );
}

export default StatutoryTable;
